import dataModel from '../../models/DataModel.js';
import inventoryItemService from '../../services/inventoryItemService';
import ReduxConstants from '../../constants/ReduxConstants.js';
import AOCollection from './AOCollection';

export default class InventoryItemsCollection extends AOCollection {
  constructor(projectId, userId, companyId, recordDescriptor, filter, subKey) {
    super({
      name: ReduxConstants.PROJECT_INVENTORY_ITEMS,
      collectionType: ReduxConstants.INVENTORY_ITEM,
      filter,
      userId,
      companyId,
      recordDescriptor,
      subKey,
    }); 
    this.projectId = projectId;
  }

  static build(projectId, userId, companyId, recordDescriptor, filter, subKey) {
    let collection = new InventoryItemsCollection(projectId, userId, companyId, recordDescriptor, filter, subKey);
    const collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  getKey(){
    return `${this.getName()}_${this.projectId}_${this.subKey}`;
  }

  handleOfflineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchCurrent(options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOfflineFetch(options);
    }
    else {
      const serviceCall = inventoryItemService.getInventoryItems.bind(this, this.projectId);
      let newCollection = await this._fetchData(serviceCall, options, true);
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/InventoryItemsCollection.js